import { IRoom } from "./SiteLocation.types";

export interface IBooking {
    Id: number;
    Start: string;
    Finish: string;
    OnBehalfOfEmail: string;
    BookedByUserId: number;
    BookedByUserName: string;
    Description: string;
    DeskId?: number;
    SiteId?: number;
    LocationId?: number;
    RoomId?: number;
    FloorplanId: string;
    LayoutId: number;
    IncludeParking: boolean;
    CancelledByAdmin?: boolean;
    CancellationReason?: string;
    CancelledByUserId?: number;
    CancelledByUserName?: string;
    CheckedInByUserId?: number;
    CheckedInByUserName?: string;
    CheckedInByOther?: string;
    Status?: BookingStatus;
}

export interface IMyBooking extends IBooking {
    SiteName: string;
    LocationName: string;
    FloorplanName: string;
    DeskName: string;
    RoomName: string;
    PostCode: string;
}

export interface ICheckInBookings {
    PreviousMeeting?: IBooking;
    UpcomingMeeting?: IBooking;
    RoomDetails: IRoom;
}

export interface IBookingSearchParams {
    FromDate?: string;
    ToDate?: string;
    UserId?: number;
    SiteId?: number;
    LocationId?: number;
    FloorplanId?: string;
    DeskId?: number;
}

export interface IAvailableRoomSlot {
    ID: number;
    SiteID: number;
    LocationID: number;
    Name: string;
    Capacity: number;
    Equipment?: string;
    Disabled: boolean;
    RestrictRoomAccess: boolean;
    Hidden: boolean;
    Start: string;
    Finish: string;
}
export interface IRoomAvailability {
    clear: IRoom[];
    busy: IRoom[];
}

export interface IBookingConstraint {
    [index: string]: number | undefined | null;
    Id?: number | undefined;
    SiteId?: number | null;
    LocationId?: number | null;
    RoomId?: number | null;
    Number?: number | undefined;
    Type?: number | undefined;
    ResourceType?: number | undefined;
}

export enum BookingStatus {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
    Cancelled = 3,
    AutoCancel = 4
}

export enum ResourceType {
    Room = 1,
    Desk = 2
}

export enum AccessType {
    Room = 1,
    Desk = 2
}

export enum ConstraintType {
    Week = 1,
    Month = 2,
    Year = 3
}